import angular from 'angular';

(function () {
    'use strict';

    angular.module('app.registration_request', []);
})();
